import { SET_DRAGGING_DESTINATION } from "./types"

export const setDraggingDestination = (data) => {
   return ({type: SET_DRAGGING_DESTINATION, payload: data});
}